import { render } from "./ProgramOutcomes.vue?vue&type=template&id=b847b1a4"
import script from "./ProgramOutcomes.vue?vue&type=script&lang=js"
export * from "./ProgramOutcomes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__